import {TFunction} from "i18next";

/**
 * Extract a meaningful, localized error message from an API error response.
 * Shows specific error only for username/password mismatch.
 * All other errors show a generic support message.
 */
export function getIdentityErrorMessage(error: any, t: TFunction): string {
  try {
    const identityErrorStr = error?.data?.Errors?.IdentityError?.[0];
    if (identityErrorStr) {
      const identityError = JSON.parse(identityErrorStr);
      const code = identityError?.error_description;

      // Only show specific error for username/password mismatch
      if (code === "invalid_username_or_password") {
        return t("email_login.messages.invalidUsernameOrPassword");
      }
    }
  } catch (e) {
    console.warn("Error parsing IdentityError", e);
  }

  // Generic fallback for all other errors
  return t("email_login.messages.genericSignInError");
}
